<template>
  <div class="showcase-collections-view">
    <align flex collapse-end direction="flex-start">
      <div class="showcase-input-wrapper">
        <search-area
          v-model="query"
          class="input"
        />
      </div>

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>

    <div class="results">
      <empty-state
        v-if="showEmptyState"
        icon="search_off"
        title="There are no results for your query"
        description="Try searching for something else"
      />

      <template>
        <div class="list">
          <div
            v-for="collection in collections"
            :key="collection.id"
          >
            <showcase-collection-item :collection="collection" />
          </div>
        </div>

        <infinite-scroll
          :loading="loading"
          :has-more-data="hasMoreData"
          @load="loadMore"
        />
      </template>
    </div>

    <scroll-top />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';

import { SHOWCASE_COLLECTION_SORT_OPTIONS } from '@cardladder/shared/constants';

import DirectionSortOptions from '@cardladder/shared/components/DirectionSortOptions';
import ShowcaseCollectionItem from './ShowcaseCollectionItem';

import { searchService } from '@/services';

export default {
  components: {
    DirectionSortOptions,
    ShowcaseCollectionItem,
  },

  data() {
    return {
      limit: 20,
      collections: [],
      loading: false,
      loaded: false,
      hasMoreData: true,
      page: 1,
      sort: 'dateAdded',
      direction: 'desc',
      sortOptions: SHOWCASE_COLLECTION_SORT_OPTIONS,
    };
  },

  created() {
    this.reset = debounce(this.reset, 500);
    this.reset();
  },

  watch: {
    sort() {
      this.reset();
    },

    direction() {
      this.reset();
    },

    query() {
      this.reset();
    },

    page(value) {
      if (value > 1) {
        this.search();
      }
    },
  },

  computed: {
    query: {
      get() {
        return this.$store.state.showcaseCollectionsQuery;
      },

      set(value) {
        this.$store.commit('SET_SHOWCASE_COLLECTIONS_QUERY', value);
      },
    },

    showEmptyState() {
      return !this.loading && this.loaded && this.collections.length === 0;
    },
  },

  methods: {
    reset() {
      this.page = 1;
      this.hasMoreData = true;
      this.loaded = false;

      this.search(true);
    },

    loadMore() {
      this.page += 1;
    },

    async search(reset = false) {
      try {
        this.loading = true;

        const data = await searchService.search({
          index: 'collections',
          query: this.query,
          page: this.page,
          limit: this.limit,
          sort: this.sort,
          direction: this.direction,
          filters: {
            public: true,
          },
        });

        const collections = data.hits;

        if (reset) {
          this.collections = collections;
        } else {
          this.collections = [...this.collections, ...collections];
        }

        if (collections.length < this.limit) {
          this.hasMoreData = false;
        }
      } catch (e) {
        // swallow
      }

      this.loaded = true;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.results {
  position: relative;
  flex: 1;
  margin-top: $gp;
}

.showcase-input-wrapper {
  width: 100%;
}

.list {
  @media($medium-down) {
    margin: 0 (-$gp);
  }
}
</style>
